import './App.css';
import AppRoutes from './router/AppRoutes';

function App() {
  return (
    <AppRoutes/>
  );
}

export default App;